import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import { GeneralStyles } from "../../../assets/css/general.styles";
import {   Grid } from "@mui/material";
import GridStyles from "../../../assets/css/grid.styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CustomButton from "../../../components/customButton/customButton"; 
import { 
  SAVE_SUCCESSFULLY,
  VALIDATION_ERROR_CONFIRM_PASSWORD_REQUIRED_MESSAGE,
  VALIDATION_ERROR_EMAIL_REQUIRED_MESSAGE,
  VALIDATION_ERROR_FIELDS_REQUIRED_MESSAGE,
  VALIDATION_ERROR_PASSWORD_LOWERCASE_REQUIRED_MESSAGE,
  VALIDATION_ERROR_PASSWORD_NOT_MATCH_REQUIRED_MESSAGE,
  VALIDATION_ERROR_PASSWORD_NUMBER_REQUIRED_MESSAGE,
  VALIDATION_ERROR_PASSWORD_REQUIRED_MESSAGE,
  VALIDATION_ERROR_PASSWORD_SPECIAL_REQUIRED_MESSAGE,
  VALIDATION_ERROR_PASSWORD_UPPERCASE_REQUIRED_MESSAGE,
  VALIDATION_ERROR_REQUIRED_MESSAGE,  
} from "../../../constants/actions";  
import { toast } from "react-toastify";  
import { UserTouched } from "./userTouched";
import { UserResource } from "../../../models/resource/userResource";
import { getUserById, saveUser } from "../../../reducers/userReducer";
import { UserModel } from "../../../models/models/userModel"; 
import Loader from "../../../components/loader";
import CustomTextField from "../../../components/customTextField/customTextField";
import { emailRegex, Lowercase, Numbercase, passwordCharactersMinimum, SpecialChar, Uppercase } from "../../../constants/registerConstants";
import CustomTabs from "../../../components/customTabs/customTabs";

const UserDetailsForm: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const authToken = useSelector((state: RootState) => state.auth.token);
  const [touched, setTouched] = useState<UserTouched>({}); 
  const [confirmPassword, setConfirmPassword] = useState<string>(""); 
  const user = useSelector((state: RootState) => state.user.user);  
  const [selectedTab, setSelectedTab] = useState(1);
  const [formData, setFormData] = useState<UserResource>({
    id: 0,
    firstName: "", 
    lastName: "", 
    email: "", 
    password: ""  
  }); 

  useEffect(() => {
    if (!authToken) {
      navigate("/Signin");
    }
  }, [authToken]); 

  useEffect(() => {
    if (id) {
      const itemId = parseInt(id, 10);
      dispatch(getUserById({ id: itemId }));
    }
  }, [id]); 

  useEffect(() => {
    const itemData = user.data;
    if (itemData && id) {
      const data = itemData as UserModel;
      setFormData({
        id: data.id || 0, 
        firstName: data.firstName || "", 
        lastName: data.lastName || "", 
        email: data.email || "", 
        password:  "", 
      });
    }
  }, [user.data]);  

    const handleEmailBlur = () => {
      if (!emailRegex.test(formData.email)) {
        setTouched((prevData) => ({
          ...prevData,
          email: true,
        }));
      }
    }; 

    const handleConfirmPasswordBlur = () => { 
      if (confirmPassword.trim() === "" || confirmPassword !== formData.password) {
          setTouched((prevData) => ({
              ...prevData,
              confirmPassword: true,
          })) 
      } 
    }; 

    const handlePasswordBlur = () => { 
        if (formData.password.length < passwordCharactersMinimum || !Uppercase.test(formData.password) || !Lowercase.test(formData.password) || !Numbercase.test(formData.password) || !SpecialChar.test(formData.password) 
      ) {
            setTouched((prevData) => ({
                ...prevData,
                password: true,
            })) 
        } 
      };

  const handleSave = () => {
    if (
      formData.firstName.trim() === ""  || 
      formData.lastName.trim() === ""  || 
      formData.email.trim() === ""   
    ) {
      let touchedFields = {
        firstName: formData.firstName.trim() === "", 
        lastName: formData.lastName.trim() === "", 
        email: formData.email.trim() === "",  
      };
      setTouched(touchedFields);
      toast.error(`${VALIDATION_ERROR_FIELDS_REQUIRED_MESSAGE}`);
      return;
    }

    if ((!id && (formData.password.trim() === "" || confirmPassword.trim() === "" || formData.password.trim() !== confirmPassword.trim())) ||
    (formData.password.trim() !== confirmPassword.trim())) {
      let touchedFields = {
        firstName: false,
        lastName: false,
        username: false,
        password: formData.password.trim() === "" ,
        confirmPassword: confirmPassword.trim() === "" || formData.password.trim() !== confirmPassword.trim(),
        email: false,
        roleId: false,
      };
      setTouched(touchedFields);
      toast.error(`${VALIDATION_ERROR_FIELDS_REQUIRED_MESSAGE}`);
      return;
    }

    if (id && formData.password.trim() !== "" && (confirmPassword.trim() === "" || formData.password.trim() !== confirmPassword.trim())) {
      let touchedFields = {
        firstName: false,
        lastName: false,
        username: false,
        password: formData.password.trim() === "" ,
        confirmPassword: confirmPassword.trim() === "" || formData.password.trim() !== confirmPassword.trim(),
        email: false,
        roleId: false,
      };
      setTouched(touchedFields);
      toast.error(`${VALIDATION_ERROR_FIELDS_REQUIRED_MESSAGE}`);
      return;
    } 

    dispatch(saveUser({ data: formData }))
      .unwrap()
      .then((response) => {
        const {success, message} = response;
        if (success) {
          toast.success(`${SAVE_SUCCESSFULLY}`);
          navigate("/Users");
        }else{
            toast.warning(`${message}`);
        }
      })
      .catch((error) => {
        console.error("Failed to save item:", error);
      });
  }; 

  const handleTabChange = ( newValue: number) => {
    setSelectedTab(newValue);
  };  

  const tabs = [ 
    { id: 1, label: 'Personal Information' }, 
    { id: 2, label: 'Change Password' },   
  ];  

  return (
    <form style={GeneralStyles.formContainerStyle}>
       {user.isLoading && <Loader />}  
        <Grid
          container
          spacing={2}
          sx={{ flexDirection: { xs: "column", sm: "row" } }}
        >
          <Grid item xs={12} sm={6} md={10}>
            <Grid item xs={12} sm={6} md={8}>
              {id ? (
                <h1 style={GridStyles.title}>
                  Edit User{" "}
                  <b>
                      {formData.firstName}
                  </b>
                </h1>
              ) : (
                <h1 style={GridStyles.title}>Add User</h1>
              )}
            </Grid> 
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <div style={GridStyles.addButtonContainer}>
              <CustomButton
                type="button"
                style={GridStyles.addButton}
                onClick={handleSave}
              >
                <CheckCircleIcon style={GridStyles.iconStyle} /> Save
              </CustomButton>
            </div>
          </Grid>  
          <Grid item xs={12} sm={12} md={12}>
            {id && <CustomTabs
                selectedTab={selectedTab}
                handleTabChange={handleTabChange}
                tabs={tabs} 
              />
            }
            {selectedTab === 1 && (
              <>
              <Grid container item xs={12} sm={12}  mt={1} md={12} spacing={2}>
                  <Grid item xs={12} sm={4}>
                      <CustomTextField 
                          label="First Name"
                          name="firstName"
                          type="text" 
                          value={formData.firstName} 
                          onChange={(e) =>
                              setFormData((prevData) => ({ ...prevData, firstName: e.target.value }))
                          }
                          required={true}
                          error={touched.firstName && formData.firstName.trim() === ""}
                          helperText={
                              touched.firstName && formData.firstName.trim() === ""
                              ? VALIDATION_ERROR_REQUIRED_MESSAGE
                              : ""
                              } 
                      />
                  </Grid>  
                  <Grid item xs={12} sm={4}>
                      <CustomTextField 
                          label="Last Name"
                          name="lastName"
                          type="text" 
                          value={formData.lastName} 
                          onChange={(e) =>
                              setFormData((prevData) => ({ ...prevData, lastName: e.target.value }))
                          }
                          required={true} 
                          error={touched.lastName && formData.lastName.trim() === ""}
                          helperText={
                              touched.lastName && formData.lastName.trim() === ""
                              ? VALIDATION_ERROR_REQUIRED_MESSAGE
                              : ""
                              } 
                      />
                  </Grid> 
                  <Grid item xs={12} sm={4}>
                      <CustomTextField 
                          label="Email"
                          name="email"
                          type="text" 
                          value={formData.email} 
                          onBlur={handleEmailBlur}
                          onChange={(e) =>
                              setFormData((prevData) => ({ ...prevData, email: e.target.value }))
                          }
                          required={true}
                          disabled = {formData.id !== 0}
                          error={touched.email && (formData.email.trim() === "" || !emailRegex.test(formData.email))}
                          helperText={
                            touched.email && (formData.email.trim() === "" || !emailRegex.test(formData.email))
                              ? VALIDATION_ERROR_EMAIL_REQUIRED_MESSAGE
                              : ""
                          } 
                      />
                  </Grid> 
              </Grid> 
              {!id &&(
              <Grid container item xs={12} sm={12}  mt={1} md={12} spacing={2}>
                <Grid item xs={12} sm={4}>
                  <CustomTextField 
                    label="Password"
                    name="password"
                    type="password" 
                    value={formData.password}
                    onChange={(e) =>
                      setFormData((prevData) => ({
                        ...prevData,
                        password: e.target.value,
                      }))
                    }
                    required={true}
                    onBlur={handlePasswordBlur}
                    error={touched.password && (
                      formData.password.trim() === "" || formData.password.length < passwordCharactersMinimum || !Uppercase.test(formData.password) || !Lowercase.test(formData.password) || !Numbercase
                      .test(formData.password) || !SpecialChar.test(formData.password) 

                    )}
                    helperText={
                        (touched.password && (formData.password.trim() === "" || formData.password.length < passwordCharactersMinimum))
                        ? VALIDATION_ERROR_PASSWORD_REQUIRED_MESSAGE
                        : (touched.password && !Uppercase.test(formData.password))  ?VALIDATION_ERROR_PASSWORD_UPPERCASE_REQUIRED_MESSAGE
                        : (touched.password && !Lowercase.test(formData.password))  ? VALIDATION_ERROR_PASSWORD_LOWERCASE_REQUIRED_MESSAGE
                        : (touched.password && !Numbercase.test(formData.password))  ? VALIDATION_ERROR_PASSWORD_NUMBER_REQUIRED_MESSAGE
                        : (touched.password && !SpecialChar.test(formData.password))  ?  VALIDATION_ERROR_PASSWORD_SPECIAL_REQUIRED_MESSAGE              
                        : ""
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <CustomTextField  
                    label="Confirm Password"
                    name="confirmPassword" 
                    type="password" 
                    value={confirmPassword}
                    onChange={(e) =>
                      setConfirmPassword(e.target.value) 
                    }
                    required={true} 
                    onBlur={handleConfirmPasswordBlur}
                    error={touched.confirmPassword && (confirmPassword.trim() === "" || confirmPassword !== formData.password)} 
                    helperText={
                      touched.confirmPassword && confirmPassword.trim() === "" ? VALIDATION_ERROR_CONFIRM_PASSWORD_REQUIRED_MESSAGE: 
                      touched.confirmPassword && confirmPassword !== formData.password ? VALIDATION_ERROR_PASSWORD_NOT_MATCH_REQUIRED_MESSAGE  : ""}
                  />
                </Grid>
              </Grid>
              )}
              </>
            )}
            {selectedTab === 2 && (
              <Grid container item xs={12} sm={12}  mt={1} md={12} spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <CustomTextField 
                      label="Password"
                      name="password"
                      type="password" 
                      value={formData.password}
                      onChange={(e) =>
                        setFormData((prevData) => ({
                          ...prevData,
                          password: e.target.value,
                        }))
                      }
                      required={true}
                      onBlur={handlePasswordBlur}
                      error={touched.password && (
                        formData.password.trim() === "" || formData.password.length < passwordCharactersMinimum || !Uppercase.test(formData.password) || !Lowercase.test(formData.password) || !Numbercase
                        .test(formData.password) || !SpecialChar.test(formData.password) 

                      )}
                      helperText={
                          (touched.password && (formData.password.trim() === "" || formData.password.length < passwordCharactersMinimum))
                          ? VALIDATION_ERROR_PASSWORD_REQUIRED_MESSAGE
                          : (touched.password && !Uppercase.test(formData.password))  ?VALIDATION_ERROR_PASSWORD_UPPERCASE_REQUIRED_MESSAGE
                          : (touched.password && !Lowercase.test(formData.password))  ? VALIDATION_ERROR_PASSWORD_LOWERCASE_REQUIRED_MESSAGE
                          : (touched.password && !Numbercase.test(formData.password))  ? VALIDATION_ERROR_PASSWORD_NUMBER_REQUIRED_MESSAGE
                          : (touched.password && !SpecialChar.test(formData.password))  ?  VALIDATION_ERROR_PASSWORD_SPECIAL_REQUIRED_MESSAGE              
                          : ""
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <CustomTextField  
                      label="Confirm Password"
                      name="confirmPassword" 
                      type="password" 
                      value={confirmPassword}
                      onChange={(e) =>
                        setConfirmPassword(e.target.value) 
                      }
                      required={true} 
                      onBlur={handleConfirmPasswordBlur}
                      error={touched.confirmPassword && (confirmPassword.trim() === "" || confirmPassword !== formData.password)} 
                      helperText={
                        touched.confirmPassword && confirmPassword.trim() === "" ? VALIDATION_ERROR_CONFIRM_PASSWORD_REQUIRED_MESSAGE: 
                        touched.confirmPassword && confirmPassword !== formData.password ? VALIDATION_ERROR_PASSWORD_NOT_MATCH_REQUIRED_MESSAGE  : ""}
                    />
                  </Grid>
              </Grid>
            )}
          </Grid>
        </Grid> 
    </form>
  );
};

export default UserDetailsForm;
